import React from "react";

function RouteFallback() {
  return (
    <div style={{ padding: "96px 24px", textAlign: "center" }}>
      Loading...
    </div>
  );
}

export default RouteFallback;
